function initAccordion(scope) {
  const isDesktop = () => window.innerWidth >= 1024;
  const items = scope.querySelectorAll('.accordion-item');
  const desktopContainer = scope.querySelector('.accordion-container-desktop');

  if (!items.length) return;

  function closeAll() {
    items.forEach(item => item.classList.remove('active'));
  }

  function openAccordion(item) {
    closeAll();
    item.classList.add('active');
  }

  function updateDesktopContent() {
    const active = scope.querySelector('.accordion-item.active');
    if (isDesktop() && desktopContainer && active) {

      const answer = active.querySelector('.accordion-answer-receive');
      if (answer) {
        desktopContainer.innerHTML = answer.innerHTML;

        desktopContainer.className = 'accordion-container-desktop';

        const typeDiv = answer.querySelector('div');
        if (typeDiv && typeDiv.className) {
          desktopContainer.classList.add(typeDiv.className);
        }
      }
    }
  }

  function handleClick(item) {
    if (isDesktop()) {
      openAccordion(item);
      updateDesktopContent();
      return false;
    } else {
      const isActive = item.classList.contains('active');
      closeAll();
      if (!isActive) {
        item.classList.add('active');
        return true;
      }
      return false;
    }
  }

  function updateMobileAnswers() {
    if (!isDesktop()) {
      items.forEach(item => {
        const answer = item.querySelector('.accordion-answer-receive');
        if (item.classList.contains('active')) {
          answer.style.display = 'flex';
        } else {
          answer.style.display = 'none';
        }
      });
    }
  }

  items.forEach(item => {
    const title = item.querySelector('.accordion-title');
    title.addEventListener('click', function () {
      const openedOnMobile = handleClick(item);
      if (!isDesktop()) {
        updateMobileAnswers();
        const skipAutoScroll = title.dataset.skipAccordionAutoScroll === '1';
        if (openedOnMobile && !skipAutoScroll) {
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          requestAnimationFrame(() => {
            title.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });
          });
        }
      }
    });
  });

  function setInitialState() {
    closeAll();
    if (isDesktop()) {

      if (items.length > 0) {
        items[0].classList.add('active');
        updateDesktopContent();
      }
      if (desktopContainer) desktopContainer.style.display = 'flex';
      items.forEach(item => {
        item.querySelector('.accordion-answer-receive').style.display = 'none';
      });
    } else {

      if (desktopContainer) desktopContainer.style.display = 'none';
      items.forEach(item => {
        const answer = item.querySelector('.accordion-answer-receive');
        answer.style.display = 'none';
      });
    }
  }

  setInitialState();

  let lastIsDesktop = isDesktop();
  window.addEventListener('resize', function () {
    const nowIsDesktop = isDesktop();
    if (nowIsDesktop !== lastIsDesktop) {
      setInitialState();
      lastIsDesktop = nowIsDesktop;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initAccordion(document));
document.addEventListener('shopify:section:load', (e) => initAccordion(e.target));